/**
 * Split rich-text HTML into alternating html / audio / video segments without loading <img> URLs.
 * Uses DOMParser so detached innerHTML does not trigger image network requests.
 */
export function parseHtmlSegments(html) {
    if (!html) return [];

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const tempDiv = doc.body;

    const mediaElements = [];

    tempDiv.querySelectorAll('.audio-player-wrapper').forEach((el) => {
        const src = el.getAttribute('data-audio-src');
        const id = el.getAttribute('data-audio-id') || `audio-${Math.random()}`;
        if (src) mediaElements.push({ type: 'audio', src, id, element: el });
    });

    tempDiv.querySelectorAll('audio[controls]').forEach((el) => {
        const src = el.getAttribute('src');
        const id = `audio-raw-${Math.random()}`;
        if (src) mediaElements.push({ type: 'audio', src, id, element: el });
    });

    tempDiv.querySelectorAll('.video-player-wrapper').forEach((el) => {
        const src = el.getAttribute('data-video-src');
        const id = `video-${Math.random()}`;
        if (src) mediaElements.push({ type: 'video', src, id, element: el });
    });

    tempDiv.querySelectorAll('iframe').forEach((el) => {
        if (el.closest('.video-player-wrapper') || el.closest('.embed-responsive')) return;
        const src = el.getAttribute('src');
        const id = `video-raw-${Math.random()}`;
        if (src) mediaElements.push({ type: 'video', src, id, element: el });
    });

    mediaElements.sort((a, b) => {
        const pos = a.element.compareDocumentPosition(b.element);
        return pos & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });

    const markers = [];
    mediaElements.forEach((item, index) => {
        const marker = doc.createElement('span');
        marker.setAttribute('data-audio-marker', String(index));
        marker.style.display = 'none';
        item.element.parentNode?.replaceChild(marker, item.element);
        markers.push({ index, src: item.src, id: item.id, type: item.type });
    });

    const htmlStr = tempDiv.innerHTML;
    const parts = [];
    let lastIndex = 0;

    markers.forEach((marker) => {
        const markerRegex = new RegExp(`<span[^>]*data-audio-marker="${marker.index}"[^>]*>[^<]*</span>`);
        const match = htmlStr.slice(lastIndex).match(markerRegex);
        if (match) {
            const pos = htmlStr.indexOf(match[0], lastIndex);
            if (pos !== -1) {
                if (pos > lastIndex) {
                    parts.push({ type: 'html', content: htmlStr.slice(lastIndex, pos) });
                }
                parts.push({ type: marker.type || 'audio', src: marker.src, id: marker.id });
                lastIndex = pos + match[0].length;
            }
        }
    });

    if (lastIndex < htmlStr.length) {
        parts.push({ type: 'html', content: htmlStr.slice(lastIndex) });
    }

    return parts;
}
